import(/* webpackMode: "eager" */ "/app/apps/web/app/[locale]/compatibility/page.tsx");
